<template>
  <vs-popup title="Ajouter un client" :active.sync="isPromptActiveLocal">
    <vs-row>
      <vs-select
        placeholder="Selectionnez un charger"
        autocomplete
        class="w-full"
        label="Charger d'affaire"
        v-model="form.charger"
        :danger="error_data.user_id ? true : false"
        :danger-text="error_data.user_id ? error_data.user_id[0] : ''"
      >
        <vs-select-item :key="index" :value="item.id" :text="item.name + ' ' + item.first_name" v-for="(item,index) in charger" />
      </vs-select>
    </vs-row>
    <vs-button color="primary" class="mt-2" type="filled" @click="assignation()">Ajouter</vs-button>
    <vs-button color="primary" class="mt-2 ml-2" type="border" @click="close()">Annuler</vs-button>
  </vs-popup>
</template>

<script>
    export default {
        name: "charger",
        props: {
          isPromptActive: {
            type: Boolean,
            required: true
          },
          charger: {
            type: Array
          },
          refreshContent: {
            type: Function
          }
        },
        watch: {
          isPromptActive(val) {
            if (!val) return;
          }
        },
        computed: {
          isPromptActiveLocal: {
            get() {
              return this.isPromptActive
            },
            set(val) {
              if (!val) {
                this.form.charger = ''
                this.error_data = {}
                this.$emit('closePrompt')
              }
            }
          },
        },
        data: () => ({
          form: {
            charger: ''
          },
          error_data: {}
        }),
        methods: {
          close(){
            this.form.charger = ''
            this.error_data = {}
            this.$emit('closePrompt')
          },
          assignation(){
            if (this.form.charger !== ''){
              this.$vs.loading()
              this.$http.post('/requests/assign', {
                id: this.$route.params.id,
                user_id: this.form.charger
              }).then((response) => {
                this.$vs.loading.close()
                if (response.data.status){
                  this.close()
                  this.refreshContent()
                  window.GETCCMT.success('La demande a été assigné', {});
                }else {
                  window.GETCCMT.error({ message: 'Une erreur est survenu lors de l\'opération.' });
                }
              }).catch((error) =>{
                console.log(error)
                if (error.response.status == 422) {
                  this.error_data = error.response.data.errors;
                }
                this.$vs.loading.close()
              })
            }else {
              window.GETCCMT.error({ message: 'Veuillez selectionner un charge d\'affaire' });
            }
          }
        }
    }
</script>

<style scoped>

</style>
